import { ContactoReadingDtoProps } from "api/DTOs/ContactoReadingDto"
import { EmpresaGetUsuarioLoggedDtoProps } from "api/DTOs/EmpresaGetUsuarioLoggedDto"
import { FacturaReadingDtoProps } from "api/DTOs/FacturaReadingDto"
import { ImpuestoEmpresaReadingDtoProps } from "api/DTOs/ImpuestoEmpresaReadingDto"
import { TIPO_GRUPO_IMPUESTO } from "api/Types/TipoGrupoImpuesto"
import { TIPO_IMPUESTO_EMPRESA_ENUM } from "api/Types/TipoImpuestoEmpresaEnum"
import {
  MODES_DOCUMENTOS,
  TYPES_DOCUMENTOS,
} from "features/Crear/pages/FormCreacionDocumento/constant"
import { FormasPago } from "features/Crear/pages/FormCreacionDocumento/hooks/ConvertirDocumento/ConvertirDocumento"
import { TFunction } from "i18next"
import { convertImgBase64 } from "utils/convertBase64"

interface FacturaARectificarParams {
  t: TFunction
  id: string
  documento: FacturaReadingDtoProps
  librado: ContactoReadingDtoProps
  librador?: EmpresaGetUsuarioLoggedDtoProps

  formasPago: FormasPago[]
  tiposImpuestosGenerales: $TSMigrationFixMe
  docAsociado: FacturaReadingDtoProps["serie"]
  esBorrador?: boolean
}

export const rectificarOeditarMapObj = ({
  t,
  id,
  documento,
  librado,
  librador,
  formasPago,
  tiposImpuestosGenerales,
  docAsociado,
  esBorrador,
}: FacturaARectificarParams) => ({
  ...documento,
  ...(esBorrador
    ? {
        adjuntos: documento?.adjuntos?.map((adjunto) => ({
          archivo: {
            path: adjunto?.nombre,
            name: adjunto?.nombre,
            size: adjunto?.tamañoEnBytes,
            type: adjunto?.tipo,
          },
          base64: adjunto.fileAsBase64,
        })),
        logoAsBase64: convertImgBase64({
          base64: documento.logo?.fileAsBase64,
          mediaType: documento.logo?.mediaType,
        }),
      }
    : {}),
  mode: MODES_DOCUMENTOS.VENTA,
  type: esBorrador
    ? TYPES_DOCUMENTOS.FACTURA
    : TYPES_DOCUMENTOS.FACTURA_RECTIFICATIVA,
  docAsociado: `${t("newDoc.factura.invoiceTitle")}: ${docAsociado}`,
  esBorrador,
  ...(esBorrador ? { modoEditarBorrador: esBorrador } : {}),
  facturaRectificativa: {
    id,
    codigoRectificativa: undefined,
    motivo: undefined,
    tipoFacturaRectificativa: undefined,
  },
  librado,
  librador,
  articuloDocumentos: documento?.articuloDocumentos
    ?.map((item) => ({
      articulo: {
        concepto: item?.articulo?.concepto,
        precioVenta: item?.articulo?.precioVenta,
      },
      cantidad: item?.cantidad,
      cuentaContableCategoriaId: item?.cuentaContableCategoriaId,
      impuestoArticuloPorcentaje: item?.tarifaImpuesto,
      orden: item?.orden,
      tarifaImpuesto: item?.tarifaImpuesto,
    }))
    .sort((a, b) => (a?.orden ?? 0) - (b?.orden ?? 0)),
  config: {
    screen: 3,
    formasPago,
    cuentaContableMultiple:
      !!documento?.articuloDocumentos?.[0]?.cuentaContableCategoriaId,
    tiposImpuestosRepercutidos: tiposImpuestosGenerales.filter(
      (tax: ImpuestoEmpresaReadingDtoProps) =>
        tax.tipo === TIPO_IMPUESTO_EMPRESA_ENUM.VENTA &&
        tax?.grupoImpuesto?.tipoGrupoImpuesto ===
          TIPO_GRUPO_IMPUESTO.IMPUESTO_REPERCUTIDO
    ),
  },
})
